var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: { size: "auto", title: "Update inspection PDF" },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm.inspection.property
          ? _c("div", { staticClass: "row gutter-sm" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("p", [
                  _c("b", [
                    _vm._v(
                      "Inspection id " +
                        _vm._s(_vm.inspection.id) +
                        " for " +
                        _vm._s(_vm.inspection.property.short_address) +
                        "."
                    )
                  ])
                ]),
                _c("p", [
                  _vm._v(
                    "\n          Replacing the PDF will change the report PM's see on their web app, but no additional report emails will be sent.\n        "
                  )
                ])
              ]),
              _c(
                "div",
                { staticClass: "row gutter-sm" },
                [
                  _c(
                    "q-field",
                    {
                      staticClass: "col-6",
                      attrs: {
                        error: _vm.get(_vm.$v.payload, "report_file.$error"),
                        "error-label": "This field is required"
                      }
                    },
                    [
                      _c("input", {
                        attrs: {
                          type: "file",
                          placeholder: "Report file (PDF)",
                          accept: "application/pdf"
                        },
                        on: {
                          change: function(event) {
                            return (_vm.payload.report_file =
                              event.target.files[0])
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "q-btn-group",
            { attrs: { rounded: "", flat: "" } },
            [
              _c("q-btn", {
                attrs: {
                  disable: !_vm.payload.report_file || _vm.uploading,
                  rounded: "",
                  color: "primary",
                  icon: "save",
                  size: "lg",
                  outline: "",
                  label: "Upload",
                  "no-caps": ""
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              }),
              _c("q-btn", {
                attrs: {
                  rounded: "",
                  color: "primary",
                  size: "lg",
                  outline: "",
                  label: "Close",
                  "no-caps": ""
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.close($event)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }